var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "processing-image" },
    [
      _c("v-progress-circular", {
        staticClass: "centered green--text darken-1",
        attrs: { indeterminate: "", size: 50, width: 3 },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-centered" }, [
        _vm._v(_vm._s(_vm.$t("processing"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }